import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import dealsOperations from "../deals/ducks/operations";
import documentActions from "../documents/ducks/actions";
import documentOperations from "../documents/ducks/operations";
import utils from "../utils/index";
import utilOperations from "../utils/operations";
import voucherOperations from "../voucher/ducks/operations";
import constants from "./constants";
import DealSummary from "./DealSummary";
import operations from "./ducks/operations";

const DealContainer = (props) => {
    const {
        brokersOnDeal,
        clearStatusTracker,
        getStatusTrackerData,
        handleGetDealSummary,
        isLoadingContent,
        personKey,
        role,
        user,
        values,
    } = props;

    const { id } = useParams();

    useEffect(() => {
        handleGetDealSummary(id);
        ReactGA.send({ hitType: "pageview", page: "/deal/*", title: `Deal Summary: ${id}` });
    }, []);

    useEffect(() => {
        const abortController = new AbortController();

        if (isLoadingContent) return;
        const missingData = !values?.compStatus || !values?.vouchers;
        if (missingData || values?.outsideCompFlag) {
            return;
        } else if (values?.compStatus.toLowerCase() === "closed" && values?.vouchers.length > 0) {
            let voucher = values?.vouchers.find((voucher) => voucher?.voucherStatus.toLowerCase() !== "closed");
            if (voucher === undefined) {
                voucher = values?.vouchers.at(-1);
            }
            if (!utilOperations.voucherAccessAllowed(user, role, personKey, voucher?.brokerCommission, voucher)) {
                return;
            }
            getStatusTrackerData(voucher?.voucherKey, "VOUCHER", abortController.signal);
        } else if (utilOperations.compAccessAllowed(user, role, personKey, brokersOnDeal, values)) {
            getStatusTrackerData(id, "COMP", abortController.signal);
        }
        return () => {
            abortController.abort();
            clearStatusTracker();
        };
    }, [isLoadingContent]);

    return <DealSummary {...props} dealId={id} />;
};

const mapStateToProps = (state) => {
    return {
        userProfile: state.authReducer.userProfile,
        values: state.dealReducer.dealSummary,
        loading: state.utilsReducer.loading,
        isLoading: state.utilsReducer.isLoading,
        isLoadingContent: state.utilsReducer.isLoadingContent,
        columnToSort: state.dealReducer.dealSummary.columnToSort,
        sortDirection: state.dealReducer.dealSummary.sortDirection,
        creator: state.dealReducer.creator,
        savedDocuments: state.documentsReducer.savedDocuments,
        missingRequiredDocuments: state.documentsReducer.missingRequiredDocuments,
        role: state.authReducer.userProfile.role,
        user: state.authReducer.userProfile.user,
        personKey: state.authReducer.userProfile.personKey,
        brokersOnDeal: state.dealReducer.brokersOnDeal,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleGetDealSummary: (dealId) => {
            dispatch(operations.getDealSummary(dealId));
        },
        handleSort: (columnName) => {
            dispatch(operations.handleSort(columnName));
        },
        addVoucherInstallment: (voucherKey, dealKey) => {
            return dispatch(operations.addVoucherInstallment(voucherKey, dealKey));
        },
        setLoader: (name, isLoading) => {
            dispatch(utils.operations.setLoader(name, isLoading));
        },
        startVoucher: (dealKey) => {
            return dispatch(voucherOperations.startVoucher(dealKey));
        },
        startDeal: (dealKey) => {
            return dispatch(operations.startDeal(dealKey));
        },
        handleStartReviewingAsCorporateData: (deal, currentPath) => {
            return dispatch(dealsOperations.handleStartReviewingAsCorporateData(deal, currentPath));
        },
        deleteDeal: (dealKey) => {
            return dispatch(operations.deleteDeal(dealKey));
        },
        loadDealDocumentList: (dealKey) => {
            dispatch(documentOperations.getDocuments(constants.urls.get_deal_document_list(dealKey)));
        },
        handleDownloadDealDocuments: (dealKey) => {
            dispatch(operations.downloadDealDocuments(dealKey));
        },
        clearSavedDocuments: (savedDocuments) => {
            dispatch(documentActions.receiveDocuments(savedDocuments));
        },
        getStatusTrackerData: (entityKey, entityType, abortController) => {
            dispatch(utilOperations.fetchStatusTrackerData(entityKey, entityType, abortController));
        },
        clearStatusTracker: () => {
            dispatch(utilOperations.deactivateStatusTracker());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DealContainer);
